import React from "react";

export default function AppText({
  as: Component = "span",
  variant = "body-1",
  tone = "primary",
  truncate = false,
  className = "",
  children,
  ...props
}) {
  const classes = [
    "ds-text",
    `ds-text--${variant}`,
    `ds-text--${tone}`,
    truncate ? "ds-text--truncate" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
}
